import React from "react";
import { ConvertEnglish } from "../../../../components/ConterEnglsih";
import { useGStore } from "../../../../context/Context";

const Accounting = () => {
  const {user,
    english,
    setEnglish,
    state,
    dispatch,
    customersAmountSum,
    payAmountAmountSum,
    stupidityAmountSum,} = useGStore();
  // console.log(state);
  return (
    <div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
        {/* total amount start */}
        <div className="card bg-green-700 font-black h-[180px] shadow-md">
          <div className="card-body gap-5 text-white text-center">
            <h2 className="text-lg lg:text-2xl">
              <ConvertEnglish english={"Total Amount"} bangla={"উত্তোলন হবে"} />
            </h2>

            <div className="flex gap-1 text-2xl justify-center">
              <h3>{customersAmountSum}</h3>
              <ConvertEnglish english={"$"} bangla={"৳"} />
            </div>
          </div>
        </div>
        {/* total amount end */}
        {/* Total stupidity start*/}
        <div className="card bg-red-900 font-black h-[180px] shadow-md">
          <div className="card-body gap-5 text-white  text-center">
            <h2 className="text-1xl lg:text-2xl">
              <ConvertEnglish
                english={"Total stupidity"}
                bangla={"মোট বোকেয়া"}
              />
            </h2>

            <div className="flex gap-1 text-2xl justify-center">
              <h3>{stupidityAmountSum}</h3>
              <ConvertEnglish english={"$"} bangla={"৳"} />
            </div>
          </div>
        </div>
         {/* Total stupidity end*/}
        {/* Total stupidity start*/}
        <div className="card bg-blue-700 font-black h-[180px] shadow-md">
          <div className="card-body gap-5 text-white  text-center">
            <h2 className="text-1xl lg:text-2xl">
              <ConvertEnglish
                english={"Total stupidity"}
                bangla={"উত্তোলন হয়েছে "}
              />
            </h2>

            <div className="flex gap-1 text-2xl justify-center">
              <h3>{payAmountAmountSum}</h3>
              <ConvertEnglish english={"$"} bangla={"৳"} />
            </div>
          </div>
        </div>
         {/* Total stupidity end*/}
        {/* Total stupidity start*/}
        <div className="card bg-cyan-700 font-black h-[180px] shadow-md">
          <div className="card-body gap-5 text-white  text-center">
            <h2 className="text-1xl lg:text-2xl">
              <ConvertEnglish
                english={"Total stupidity"}
                bangla={"আসবে"}
              />
            </h2>

            <div className="flex gap-1 text-2xl justify-center">
              <h3>আসবে</h3>
              <ConvertEnglish english={"$"} bangla={"৳"} />
            </div>
          </div>
        </div>
         {/* Total stupidity end*/}
      </div>
    </div>
  );
};

export default Accounting;
